<template>
  <div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3">
      <Calendar numpickers=1></Calendar>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-9 order-xl-first">
      <SummaryChart></SummaryChart>
      <BatteryOccupation v-if="has_battery"></BatteryOccupation>
    </div> 
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-9">
      <WeekChart v-if="range=='week'"></WeekChart>
    </div>  
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-9">
      <MonthChart v-if="range=='month'"></MonthChart>
    </div> 
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xl-special-4">
      <Savings></Savings>
      <ProductionNotUsed></ProductionNotUsed>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5 col-xl-special-5">
      <ConsumptionDetails></ConsumptionDetails>
    </div>
  </div>
</template>

<script>
import Savings from './Savings.vue'
import ProductionNotUsed from './ProductionNotUsed.vue'
import ConsumptionDetails from './ConsumptionDetails.vue'
import SummaryChart from './SummaryChart.vue'
import Calendar from './Calendar.vue'
import WeekChart from './WeekChart.vue'
import MonthChart from './MonthChart.vue'
import BatteryOccupation from './BatteryOccupation.vue'

export default {
  name: 'Historical',
  components: {
    Savings,
    ProductionNotUsed,
    ConsumptionDetails,
    SummaryChart,
    Calendar,
    WeekChart,
    MonthChart,
    BatteryOccupation,
  },
  computed: {
    range: function(){
      return this.$store.getters.range
    },
    has_battery: function(){
      if (this.$store.getters.user_isAdmin) return this.$store.getters.remote_user_bess
      return this.$store.getters.user_bess
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
